// The signed-in user's profile in ONE shape, whether it comes from the login response (saved before
// the first page loads) or from users/find-me (loaded after) - so the header shows the same name and
// identification code before and after the profile is fetched.
//   -> { id, name, identificationShortCode, email, role, avatar }
export const toProfile = (raw = {}, saved = {}) => {
  const name = raw.name || [raw.firstname || raw.firstName, raw.lastname || raw.lastName].filter(Boolean).join(" ") || saved.name || "";

  return {
    id: raw.id ?? saved.id,
    name,
    identificationShortCode: raw.identificationShortCode || saved.identificationShortCode || "",
    email: raw.email || saved.email || "",
    role: raw.role || raw.roles?.[0]?.name || saved.role || "",
    avatar: raw.profileImage || raw.profilePicture || raw.imageUrl || raw.avatar || saved.avatar || "",
  };
};
